module.exports = {"410825001":"温泉街道","410825002":"岳村街道","410825003":"张羌街道","410825004":"黄河街道","410825101":"祥云镇","410825102":"番田镇","410825104":"黄庄镇","410825105":"武德镇","410825106":"赵堡镇","410825201":"招贤乡","410825203":"北冷乡","410825400":"国营温县农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410825.json
// module id = 1469
// module chunks = 0